// src/pages/school_exams/template_builder/utils/templateJsonBuilder.js

/**
 * Build final template JSON for saving to database
 *
 * Backend (CI3) এ json_data->elements ধরে কাজ করবে।
 * React-এর element object গুলো ঠিক যেমন আছে তেমনই সেভ হবে।
 *
 * @param {string} background - server path of background image (uploads/..)
 * @param {Array}  elements   - all designer elements
 * @param {string} templateName
 */
export function buildTemplateJSON(background, elements, templateName = "") {
  // ছোট mapping: যেকোনো table element এর color property গুলোর জন্য
  const normalizedElements = (elements || []).map((el) => {
    if (el.type === "table") {
      return {
        ...el,
        // backend যদি snake_case চায় সে জন্য duplicate key
        header_bg_color: el.headerBgColor,
        header_text_color: el.headerTextColor,
        row_bg_color: el.rowBgColor,
        alt_row_bg_color: el.altRowBgColor,
        border_color: el.borderColor,
        border_width: el.borderWidth,
      };
    }

    if (el.type === "photo") {
      return {
        ...el,
        border_radius: el.borderRadius,
        border_width: el.borderWidth,
      };
    }

    return el;
  });

  return {
    page: {
      unit: "mm",
      width: 210, // A4 width
      height: 297, // A4 height
    },
    background: {
      file: background || "",
      page_no: 1,
    },
    meta: {
      template_name: templateName,
      version: 1,
    },
    elements: normalizedElements,
  };
}
